import {Injectable, Type} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {MvsCrudModeEnum} from "../../../../core/shared/service/crud/mvs-crud-mode.enum";

/**
 * CRUD service for TeTemplateBlueprintArtefactVariableLink entity operations.
 */
@Injectable({
    providedIn: 'root'
})
export class TeTemplateBlueprintArtefactVariableLinkService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/te/teTemplateBlueprintArtefactVariableLinks');
    }

    getObjectComponent(mode: MvsCrudModeEnum = MvsCrudModeEnum.update): Type<any> {
        return null;
    }

}
